export var InputAdornmentOverrides = function () { return ({
    MuiInputAdornment: {
        positionStart: {
            marginTop: '2px',
            marginRight: '12px',
        },
        positionEnd: {
            marginTop: '2px',
            marginLeft: '12px',
            '& > button': {
                // Button should be centered so outline looks correct when focused
                marginTop: '-2px',
                // Position above floatingLabel border when in focus
                zIndex: 1,
            },
        },
    },
}); };
//# sourceMappingURL=InputAdornment.overrides.js.map